/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadActionCreator } from "@reduxjs/toolkit";
import { createAction } from "@reduxjs/toolkit";

import {
  AddressType,
  BillEstimatePayload,
  BillEstimateResponse,
  fetchProductPayload,
  GetSignUpResponse,
  SignUpResponse,
  SupplyAddresses,
  WindcaveAuthorisation,
  WindcaveTransaction,
} from "./types";

export type SagaAction<PP = void, FP = unknown, RP = Error> = {
  request: PayloadActionCreator<PP>;
  success: PayloadActionCreator<FP>;
  failure: PayloadActionCreator<RP>;
};

export const createSagaAction = <
  PendingPayload = void,
  FulfilledPayload = unknown,
  RejectedPayload = Error,
>(
  typePrefix: string,
): SagaAction<PendingPayload, FulfilledPayload, RejectedPayload> => {
  return {
    request: createAction<PendingPayload>(`${typePrefix}/request`),
    success: createAction<FulfilledPayload>(`${typePrefix}/success`),
    failure: createAction<RejectedPayload>(`${typePrefix}/failure`),
  };
};

// ------------------------Async Actions----------------------------
export const fetchProductDataAction = createSagaAction<
  fetchProductPayload,
  any
>("coreState/fetchProductData");
export const validateAddressAction = createSagaAction<
  AddressType,
  SupplyAddresses
>("coreState/validateAddress");
export const fetchAvailableProductsAction = createSagaAction<
  BillEstimatePayload,
  BillEstimateResponse
>("coreState/fetchAvailableProducts");
export const fetchBillingEstimateAction = createSagaAction<
  void,
  BillEstimateResponse,
  Error
>("coreState/fetchBillingEstimate");
export const createWindcaveTransactionAction = createSagaAction<
  void,
  WindcaveTransaction
>("coreState/createWindcaveTransaction");
export const checkSuccessfulAuthorisationAction = createSagaAction<
  void,
  WindcaveAuthorisation
>("coreState/checkSuccessfulAuthorisation");
export const createFlickSignUpAction = createSagaAction<
  void,
  SignUpResponse,
  string
>("coreState/createFlickSignUp");
export const updateFlickSignUpAction = createSagaAction<
  void,
  SignUpResponse,
  string
>("coreState/updateFlickSignUp");
export const getFlickSignUpAction = createSagaAction<
  string,
  GetSignUpResponse,
  string
>("coreState/getFlickSignUp");
export const createPlanChooserSignUpAction = createSagaAction<
  AddressType,
  SupplyAddresses
>("coreState/createPlanChooserSignUp");
